import { useEffect, useState, useCallback } from 'react';
export const useFocusVisible = (target, onBlur, onFocus) => {
    const [isFocusVisible, setIsFocusVisible] = useState(true);
    const [focusVisible, setFocusVisible] = useState(true);
    const [focused, setFocused] = useState(false);
    const focusFunction = (event) => {
        if (onFocus)
            onFocus(event);
        setIsFocusVisible(true);
        setFocused(true);
    };
    const blurFunction = (event) => {
        if (onBlur)
            onBlur(event);
        setIsFocusVisible(false);
        setFocused(false);
    };
    useEffect(() => {
        setIsFocusVisible(focusVisible);
    }, [focused, focusVisible]);
    // KeyboardEvent
    const keyboardEventHandler = useCallback(() => {
        setFocusVisible(true);
    }, []);
    // MouseEvent
    const mouseEventHandler = useCallback(() => {
        setFocusVisible(false);
    }, []);
    const useEvent = (event, callback) => {
        useEffect(() => {
            const { current } = target;
            current.addEventListener(event, callback);
            return () => current.removeEventListener(event, callback);
        }, [event, callback]);
    };
    useEvent('mousedown', mouseEventHandler);
    useEvent('mouseup', mouseEventHandler);
    useEvent('keydown', keyboardEventHandler);
    useEvent('keyup', keyboardEventHandler);
    return { isFocusVisible, focusFunction, blurFunction };
};
//# sourceMappingURL=useFocusVisible.js.map